import * as paymentOptionsMetadataTypes from 'commons-vehicle/PaymentOptionsMetadata/actions/paymentOptionsMetadataActionTypes.js';

export function loadPaymentOptionsMetadata(paymentOptionsMetadata) {
    return { type: paymentOptionsMetadataTypes.LOAD_PAYMENT_OPTIONS_METADATA_SUCCESS, paymentOptionsMetadata };
}

export default {
    loadPaymentOptionsMetadata,
};
